import { styled } from 'styled-components'

const ModifiedModalFooter = styled('div')`
  padding: 0px 8px;
`

export default ModifiedModalFooter
